/*global $*/
/*eslint no-undef: "error"*/

import Swiper from 'swiper'
import {Autoplay, EffectCoverflow, Navigation, Pagination, Thumbs} from 'swiper/modules'

Swiper.use([Navigation, Pagination, EffectCoverflow, Autoplay, Thumbs])

export default class SwiperSlider {
	createTop() {
		return new Swiper('#slider--top', {
			navigation: {
				nextEl: '.slider--top-next',
				prevEl: '.slider--top-prev',
				disabledClass: 'slider__arrow---disabled'
			},
			pagination: {
				el: '.swiper-pagination--top',
				clickable: true
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
					spaceBetween: 16
				}
			}
		})
	}

	createProduct() {
		return new Swiper('#slider--product', {
			initialSlide: 1,
			navigation: {
				nextEl: '.slider--product-next',
				prevEl: '.slider--product-prev',
				disabledClass: 'slider__arrow---disabled'
			},
			pagination: {
				el: '.swiper-pagination--product',
				clickable: true
			},
			breakpoints: {
				0: {
					slidesPerView: 1.25,
					spaceBetween: 16,
					centeredSlides: true
				},
				640: {
					slidesPerView: 1.5,
					spaceBetween: 20,
					centeredSlides: true
				},
				1240: {
					slidesPerView: 1.75,
					spaceBetween: 20,
					centeredSlides: true
				}
			}
		})
	}

	createProductGallery() {
		let swiperBlock = new Swiper('#slider--product-gallery', {
			navigation: {
				nextEl: '.slider--product-gallery-next',
				prevEl: '.slider--product-gallery-prev',
				disabledClass: 'slider__arrow---disabled'
			},
			pagination: {
				el: '.swiper-pagination--product-gallery',
				clickable: true
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
					spaceBetween: 16
				}
			}
		})

		if ($(`.gallery-product--button`).length) {
			$(`.gallery-product--button`).click(function () {
				let block = $(this).data('block')

				swiperBlock.slideTo(block)
			})
		}

		return swiperBlock
	}

	createHome() {
		return new Swiper('#slider--home', {
			slidePrevClass: "home---prev",
			slideNextClass: "home---next",
			navigation: {
				nextEl: '.slider--home-next',
				prevEl: '.slider--home-prev',
				disabledClass: 'slider__arrow---disabled'
			},
			pagination: {
				el: '.swiper-pagination--home',
				clickable: true
			},
			breakpoints: {
				0: {
					slidesPerView: 1.375,
					spaceBetween: 16
				},
				640: {
					slidesPerView: 1.25,
					spaceBetween: 16
				},
				1240: {
					slidesPerView: 1.15,
					spaceBetween: 20
				},
			}
		})
	}

	createTagProduct() {
		let swiperObj = new Swiper('#slider--tag-product', {
			navigation: {
				nextEl: '.slider--tag-product-next',
				prevEl: '.slider--tag-product-prev',
				disabledClass: 'slider__arrow---disabled'
			},
			pagination: {
				el: '.swiper-pagination--tag-product',
				clickable: true
			},
			breakpoints: {
				0: {
					slidesPerView: "auto",
					spaceBetween: 12
				}
			}
		})

		if ($(`.tag-product--tag`).length) {
			$(`.tag-product--tag`).click(function () {
				let block = $(this).data('block')

				$(this).closest(`.swiper-wrapper`).find(`.tag-product--tag`).removeClass('tag-product---active')
				$(this).addClass('tag-product---active')

				// карточка товара
				if ($(`.product-tab--items`).length > 0) {
					$(`.product-tab--items`).find(`.product-tab--item`).removeClass('product-tab__item---active')
					$(`.product-tab--items`).find(`.product-tab--item[data-block='${block}']`).addClass('product-tab__item---active')
				}

				swiperObj.slideTo(block)
			})
		}

		return swiperObj
	}

	createBest() {
		return new Swiper('#slider--best', {
			navigation: {
				nextEl: '.slider--best-next',
				prevEl: '.slider--best-prev',
				disabledClass: 'slider__arrow---disabled'
			},
			pagination: {
				el: '.swiper-pagination--best',
				clickable: true
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
					spaceBetween: 20
				},
				640: {
					slidesPerView: 1.675,
					spaceBetween: 20
				},
				1240: {
					slidesPerView: 1.8,
					spaceBetween: 20
				},
			}
		})
	}

	createClient() {
		return new Swiper('#slider--client', {
			navigation: {
				nextEl: '.slider--client-next',
				prevEl: '.slider--client-prev',
				disabledClass: 'slider__arrow---disabled'
			},
			pagination: {
				el: '.swiper-pagination--client',
				clickable: true
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
					spaceBetween: 0
				}
			}
		})
	}

	createPartner() {
		return new Swiper('#slider--partner', {
			initialSlide: 1,
			loop: true,
			navigation: {
				nextEl: '.slider--partner-next',
				prevEl: '.slider--partner-prev',
				disabledClass: 'slider__arrow---disabled'
			},
			pagination: {
				el: '.swiper-pagination--partner',
				clickable: true
			},
			breakpoints: {
				0: {
					slidesPerView: 2.25,
					spaceBetween: 16,
					centeredSlides: true
				},
				640: {
					slidesPerView: 3.5,
					spaceBetween: 40,
					centeredSlides: true
				},
				1240: {
					slidesPerView: 4.25,
					spaceBetween: 40,
					centeredSlides: true
				},
			}
		})
	}

	createArticle() {
		return new Swiper('#slider--article', {
			navigation: {
				nextEl: '.slider--article-next',
				prevEl: '.slider--article-prev',
				disabledClass: 'slider__arrow---disabled'
			},
			pagination: {
				el: '.swiper-pagination--article',
				clickable: true
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
					spaceBetween: 16
				},
				640: {
					slidesPerView: 2,
					spaceBetween: 20
				},
				1240: {
					slidesPerView: 3,
					spaceBetween: 40
				},
			}
		})
	}

	createTagArticle() {
		let swiperObj = new Swiper('#slider--tag-article', {
			navigation: {
				nextEl: '.slider--tag-article-next',
				prevEl: '.slider--tag-article-prev',
				disabledClass: 'slider__arrow---disabled'
			},
			pagination: {
				el: '.swiper-pagination--tag-article',
				clickable: true
			},
			breakpoints: {
				0: {
					slidesPerView: "auto",
					spaceBetween: 0
				}
			}
		})

		if ($(`.tag-article--tag`).length) {
			$(`.tag-article--tag`).click(function () {
				let block = $(this).data('block')

				$(this).closest(`.swiper-wrapper`).find(`.tag-article--tag`).removeClass('tag-article---active')
				$(this).addClass('tag-article---active')

				swiperObj.slideTo(block)
			})
		}

		return swiperObj
	}

	createService() {
		return new Swiper('#slider--service', {
			navigation: {
				nextEl: '.slider--service-next',
				prevEl: '.slider--service-prev',
				disabledClass: 'slider__arrow---disabled'
			},
			pagination: {
				el: '.swiper-pagination--service',
				clickable: true
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
					spaceBetween: 16
				},
				640: {
					slidesPerView: 1.5,
					spaceBetween: 20
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 20
				}
			}
		})
	}

	createAnalog() {
		return new Swiper('#slider--analog', {
			navigation: {
				nextEl: '.slider--analog-next',
				prevEl: '.slider--analog-prev',
				disabledClass: 'slider__arrow---disabled'
			},
			pagination: {
				el: '.swiper-pagination--analog',
				clickable: true
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
					spaceBetween: 16
				},
				640: {
					slidesPerView: 1.5,
					spaceBetween: 20
				},
				1024: {
					slidesPerView: 2.5,
					spaceBetween: 20
				}
			}
		})
	}

	createBurial(sliderID) {
		return new Swiper('#slider--burial---' + sliderID, {
			navigation: {
				nextEl: `.slider--burial---${sliderID}-next`,
				prevEl: `.slider--burial---${sliderID}-prev`,
				disabledClass: 'slider__arrow---disabled'
			},
			pagination: {
				el: '.swiper-pagination--burial---' + sliderID,
				clickable: true
			},
			breakpoints: {
				0: {
					slidesPerView: 1.5,
					spaceBetween: 16
				},
				640: {
					slidesPerView: 3.25,
					spaceBetween: 20
				},
				1024: {
					slidesPerView: 3.5,
					spaceBetween: 20
				}
			}
		})
	}

	createText() {
		return new Swiper('#slider--text', {
			slidesPerView: 1,
			spaceBetween: 40,
			navigation: {
				nextEl: '.slider--text-next',
				prevEl: '.slider--text-prev',
				disabledClass: 'slider__arrow---disabled'
			},
			pagination: {
				el: '.swiper-pagination--text',
				clickable: true
			},
			breakpoints: {}
		})
	}

	constructor() {
		if (parseInt($('#slider--top').length) > 0) {
			this.createTop()
		}

		if (parseInt($('#slider--product').length) > 0) {
			this.createProduct()
		}

		if (parseInt($('#slider--product-gallery').length) > 0) {
			this.createProductGallery()
		}

		if (parseInt($('#slider--home').length) > 0) {
			this.createHome()
		}

		if (parseInt($('#slider--tag-product').length) > 0) {
			this.createTagProduct()
		}

		if (parseInt($('#slider--best').length) > 0) {
			this.createBest()
		}

		if (parseInt($('#slider--client').length) > 0) {
			this.createClient()
		}

		if (parseInt($('#slider--partner').length) > 0) {
			this.createPartner()
		}

		if (parseInt($('#slider--article').length) > 0) {
			this.createArticle()
		}

		if (parseInt($('#slider--tag-article').length) > 0) {
			this.createTagArticle()
		}

		if (parseInt($('#slider--service').length) > 0) {
			this.createService()
		}

		if (parseInt($('#slider--analog').length) > 0) {
			this.createAnalog()
		}

		if (parseInt($('#slider--text').length) > 0) {
			this.createText()
		}

		if (parseInt($('#slider--burial---1').length) > 0) {
			this.createBurial(1)
		}

		if (parseInt($('#slider--burial---2').length) > 0) {
			this.createBurial(2)
		}

		if (parseInt($('#slider--burial---3').length) > 0) {
			this.createBurial(3)
		}

		if (parseInt($('#slider--burial---4').length) > 0) {
			this.createBurial(4)
		}

		if (parseInt($('#slider--burial---5').length) > 0) {
			this.createBurial(5)
		}
	}
}
